module.exports = __webpack_public_path__ + "img/矢量智能对象拷贝4.527cabdc.png";